import { getDefaultClient } from '../../../client/defaultClient';
import { assertDefined } from '../../../utils/assertDefined';
import { getVerifiedCredentialForWalletAccount } from '../../wallets/utils/getVerifiedCredentialForWalletAccount';
import type { WalletAccount } from '../../wallets/walletAccount';

type HasDelegatedAccessParams = {
  walletAccount: WalletAccount;
};

/**
 * Checks if a WaaS wallet account has delegated access.
 *
 * @param params.walletAccount - The WaaS wallet account to check for delegated access.
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns True if the wallet account has delegated access, false otherwise.
 */
export const hasDelegatedAccess = (
  { walletAccount }: HasDelegatedAccessParams,
  client = getDefaultClient()
): boolean => {
  const verifiedCredential = getVerifiedCredentialForWalletAccount(
    { walletAccount },
    client
  );

  assertDefined(
    verifiedCredential,
    'Verified credential not found for Waas wallet account'
  );

  const hasDelegatedKeyShare =
    verifiedCredential.walletProperties?.keyShares?.some(
      (keyShare) => keyShare.backupLocation === 'delegated'
    );

  return !!hasDelegatedKeyShare;
};
